module.exports = __webpack_public_path__ + "6e44b9189d7585d74df4221d71298755.pdf";